// extracted by mini-css-extract-plugin
export default {"individualization-button":"IndividualizationButton_individualization-button__J1CMT"};